var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 82,
    viewBox: "0 0 87 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5554 4.08325H17.8047V40.3869H85.5554V4.08325Z",
    fill: "url(#paint0_linear_52_290)",
    fillOpacity: 0.1,
    stroke: "#0478FE",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4995 24.5981V30.7566",
    stroke: "#0478FE",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.51 19.1577V30.7566",
    stroke: "#0478FE",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5168 13.7173V30.7566",
    stroke: "#0478FE",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9892 59.1935C42.8015 59.1935 40.2056 56.5976 40.2056 53.4099C40.2056 50.2222 42.8015 47.6262 45.9892 47.6262C49.1769 47.6262 51.7729 50.2222 51.7729 53.4099C51.7729 56.5976 49.1769 59.1935 45.9892 59.1935Z",
    fill: "url(#paint1_linear_52_290)",
    fillOpacity: 0.1,
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5555 77.3966V70.5004C85.5555 67.4429 83.0779 64.9653 80.0244 64.9653H38.3158C35.2622 64.9653 32.7847 67.4429 32.7847 70.5004V77.3966H85.5555Z",
    fill: "url(#paint2_linear_52_290)",
    fillOpacity: 0.1,
    stroke: "url(#paint3_linear_52_290)",
    strokeOpacity: 0.1,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7654 64.9692H38.3158C35.2622 64.9692 32.7847 67.4468 32.7847 70.5043V77.4005",
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3747 59.1935C69.1831 59.1935 66.5911 56.5976 66.5911 53.4099C66.5911 50.2222 69.187 47.6262 72.3747 47.6262C75.5624 47.6262 78.1584 50.2222 78.1584 53.4099C78.1584 56.5976 75.5624 59.1935 72.3747 59.1935Z",
    fill: "url(#paint4_linear_52_290)",
    fillOpacity: 0.1,
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5556 77.3966V70.5004C85.5556 67.4429 83.078 64.9653 80.0244 64.9653H64.7013C61.6477 64.9653 59.1702 67.4429 59.1702 70.5004V77.3966",
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8046 15.6545C14.6169 15.6545 12.021 13.0585 12.021 9.87081C12.021 6.68309 14.6169 4.08716 17.8046 4.08716C20.9924 4.08716 23.5883 6.68309 23.5883 9.87081C23.5883 13.0585 20.9924 15.6545 17.8046 15.6545Z",
    fill: "url(#paint5_linear_52_290)",
    fillOpacity: 0.1,
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5372 77.3966L28.0308 28.4605H44.8925C46.6876 28.4605 48.3485 27.2335 48.6365 25.4661C49.0034 23.2094 47.2715 21.2605 45.0859 21.2605H10.092C6.77412 21.2605 4.0835 23.9511 4.0835 27.269V43.4838C4.0835 46.4466 6.48612 48.8532 9.4529 48.8532L12.0765 77.4005H23.5372V77.3966Z",
    fill: "url(#paint6_linear_52_290)",
    fillOpacity: 0.1,
    stroke: "#0478FE",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5372 77.3966L28.0308 28.4605H44.8925C46.6876 28.4605 48.3485 27.2335 48.6365 25.4661C49.0034 23.2094 47.2715 21.2605 45.0859 21.2605H10.092C6.77412 21.2605 4.0835 23.9511 4.0835 27.269V43.4838C4.0835 46.4466 6.48612 48.8532 9.4529 48.8532L12.0765 77.4005",
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0835 77.3967H12.0725",
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5371 77.3967H32.7846",
    stroke: "#0478FE",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_290",
    x1: 51.6801,
    y1: 4.08325,
    x2: 51.6801,
    y2: 40.3869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_290",
    x1: 45.9892,
    y1: 47.6262,
    x2: 45.9892,
    y2: 59.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_290",
    x1: 59.1701,
    y1: 64.9653,
    x2: 59.1701,
    y2: 77.3966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_52_290",
    x1: 59.1701,
    y1: 64.9653,
    x2: 59.1701,
    y2: 77.3966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_52_290",
    x1: 72.3747,
    y1: 47.6262,
    x2: 72.3747,
    y2: 59.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_52_290",
    x1: 17.8046,
    y1: 4.08716,
    x2: 17.8046,
    y2: 15.6545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_52_290",
    x1: 26.3846,
    y1: 21.2605,
    x2: 26.3846,
    y2: 77.4006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.6877,
    height: 81.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.8a495b80586f969e0ac59f3fdb851afd.svg";
export { ForwardRef as ReactComponent };